import LocalizedStrings from "react-localization";

const strings = new LocalizedStrings({
  en: {
    users: "Users",
    actions: "Actions",
    roles: "Roles",
    add: "Add",
    delete: "Delete",
    edit: "Edit",
    new: "New",
    defaultDeleteTitle: "Delete?",
    defaultDeleteMsg: "Are you sure you want to delete this?",
    disagree: "Disagree",
    agree: "Agree",
    defaultDeleteFailedTitle: "Delete failed",
    defaultDeleteFailedMsg:
      "Failed to delete item. Make sure its not associated with anything else.",
    close: "Close",
    error: "Error",
    audit: "Audit Logs",
    changePwd: "Change password",
    details: "Details",
    userId: "User ID",
    parameters: "Parameters",
    timestamp: "Timestamp",
    failedToLoadAuditLogs: "Failed to load audit logs",
    userName: "User name",
    auditLogs: "Audit Logs",
    failedToCreateRole: "Failed to create role",
    failedToLoadRoles: "Failed to load roles",
    nameMandatory: "Name is required.",
    name: "Name",
    cancel: "Cancel",
    create: "Create",
    failedToLoadPermissions: "Failed to load permissions",
    export: "Export",
    action: "Action",
    remove: "Remove",
    select: "Select",
    removePermissionTitle: "Remove permission?",
    removePermissionConfirmation:
      "Are you sure you want to remove this permission?",
    selectPermissions: "Select Permissions",
    deleteRoleTitle: "Delete role?",
    deleteRoleConfirmation: "Are you sure you want to delete this role?",
    roleDeleteFailedTitle: "Role deletion failed",
    roleDeleteFailedMsg:
      "Role deletion failed. Make sure no user is assigned to this role, before retrying.",
    permissions: "Permissions",
    oldPasswordMandatory: "Old password is required",
    newPasswordMandatory: "New password is required",
    shortPassword: "Password is too short (minimum {0} chars)",
    samePasswords: "Old and new passwords cannot be the same.",
    changePwdFailedTitle: "Error",
    changePwdFailedMsg: "Unable to change password",
    oldPassword: "Old password",
    newPassword: "New password",
    change: "Change",
    save: "Save",
    usernameMandatory: "Username is required.",
    passwordMandatory: "Password is required.",
    login: "Login",
    loginFailedTitle: "Login failed",
    loginFailedMsg: "Make sure username/password is correct.",
    password: "Password",
    username: "User name",
    createUser: "Create User",
    registrationFailedTitle: "Registration failed",
    registrationFailedMsg:
      "Possibly username is not unique. Try a different one.",
    next: "Next",
    finish: "Finish",
    resetPwd: "Reset password",
    newPasswd: "New password",
    update: "Update",
    back: "Back",
    removeRoleTitle: "Remove role?",
    removeRoleConfirmation: "Are you sure you want to remove this role?",
    selectRoles: "Select Roles",
    deleteUserTitle: "Delete User",
    deleteUserConfirmation: "Are you sure you want to delete this user?",
    deleteUserFailedTitle: "Failusre",
    deleteUserFailedMsg: "Failed to delete user",
    failedToLoadUsers: "Failed to load users",
    editUser: "Edit User",
    resetPasswd: "Reset password",
    bandobast: "Bandobast",
    serialNo: "Serial No.",
    newBandobast: "New Bandobast",
    failedToCreateBandobast:
      "Failed to create a new bandobast. Is the name unique?",
    points: "Points",
    failedToCreatePoint: "Failed to create Points. Is the name unique?",
    newPoint: "New Point",
    personnelAssessment: "Personnel Assessment",
    newPersonnelAssessment: "New Personnel Assessment",
    failedToCreatePersonnelAssessment:
      "Failed to create personnel assessment. Is the designation already used?",
    count: "Count",
    designations: "Designations",
    newDesignation: "New Designation",
    failedToCreateDesignation:
      "Failed to create designation. Is the designation already used?",
    designation: "Designation",
    deletePersonnelAssessmentTitle: "Delete Personnel Assessment?",
    deletePersonnelAssessmentConfirmation:
      "Are you sure you want to delete this assessment?",
    deletePersonnelAssessmentFailedTitle: "Failed to delete assessment",
    deletePersonnelAssessmentFailedMsg:
      "Failed to delete this personnel assessment. Try again later.",
    editPersonnelAssessment: "Edit Personnel assessment",
    failedToEditPersonnelAssessment:
      "Failed to update this personnel assessment. Try again later.",
    ranges: "Ranges",
    newRange: "New Range",
    failedToCreateRange: "Failed to create range. Is the name unique?",
    areas: "Areas",
    subareas: "Sub-areas",
    newArea: "New Area",
    failedToCreateArea: "Failed to create area. Is the name unique?",
    range: "Range",
    area: "Area",
    newSubarea: "New Subarea",
    failedToCreateSubarea: "Failed to create sub area. Is the name unique?",
    subarea: "Sub area",
    personnelAssessments: "Personnel Assessments",
    personnel: "Personnel",
    newPersonnel: "New Personnel",
    failedToCreatePersonnel: "Failed to add personnel",
    personnelAllocation: "Personnel Allocation",
    location: "Location",
    submit: "Submit",
    assessmentCount: "Assessment count",
    allocatedCount: "Allocated count",
    allocationLink: "Edit allocation",
    parent: "Parent",
    link: "Link",
    designationEmpty: "Designation is empty in row {0}",
    valuesEmpty: "Value is empty in row {0}",
    point: "Point",
    kind: "Kind",
    summary: "Summary",
    allocate: "Auto Allocate",
    deletePersonnelTitle: "Delete Personnel",
    deletePersonnelConfirmation:
      "Are you sure you want to delete this personnel?",
    deletePersonnelFailedTitle: "Failpersonnel",
    deletePersonnelFailedMsg: "Failed to delete personnel",
    templates: "Assessment Templates",
    template: "Template",
    address: "Address",
    nameEmpty: "Name is empty in row {0}",
    kindEmpty: "Kind is empty in row {0}",
    parentEmpty: "Parent is empty in row {0}",
    templateEmpty: "Template is empty in row {0}",
    validationErrors: "Validation errors",
    newBandobastPage1: "New Bandobast (Step 1 of 2: Details)",
    newBandobastPage2: "New Bandobast (Step 2 of 2: Locations)",
    startDate: "Start Date",
    heading: "Heading",
    subHeading: "Sub heading",
    place: "Place",
    city: "City",
    unit: "Unit",
    district: "District",
    bandobastCreationFailed:
      "Bandobast creation failed. Is the name alreay used?",
    newTemplate: "New Template",
    countEmpty: "Count is empty in row {0}",
    assessmentsEmpty: "There should be atleast one assessment",
    invalidCount: "Invalid count value",
    assessments: "Assessments",
    idNumber: "Id No.",
    mobileNumber: "Mobile No.",
    organization: "Organization",
    failedToCreateTemplate: "Failed to create template",
    failedToEditTemplate: "Failed to edit template",
    editBandobast: "Edit Bandobast",
    bandobastEditFailed: "Edit bandobast failed",
    failedToEditBandobast: "Failed to edit bandobast",
    import: "Import",
    uploadPersonnel: "Upload personnel",
    upload: "Upload",
    failedToImportPersonnel: "Failed to add personnel",
    editPersonnel: "Edit Personnel",
    failedToEditPersonnel: "Failed to edit personnel",
    editRange: "Edit Range",
    failedToEditRange: "Failed to edit range",
    editArea: "Edit Area",
    failedToEditArea: "Failed to edit area",
    editSubarea: "Edit Subarea",
    failedToEditSubarea: "Failed to edit subarea",
    editPoint: "Edit Point",
    failedToEditPoint: "Failed to edit point",
    editDesignation: "Edit Designation",
    failedToEditDesignation: "Failed to edit designation",
    deleteDesignationTitle: "Delete designation?",
    deleteDesignationConfirmation:
      "Are you sure you want to delete this designation?",
    deleteDesignationFailedTitle: "Designation delete failed",
    deleteDesignationFailedMsg:
      "Failed to delete designation. Make sure this designation is not used by any other objects (personnel, assessments, templates, etc).",
    uploadDesignation: "Upload designations",
    failedToUploadDesignation: "Failed to upload designations",
    deleteRangeFailedTitle: "Range removal failed",
    deleteRangeFailedMsg: "Failed to remove range",
    deleteRangeTitle: "Remove range",
    deleteRangeConfirmation: "Are you sure you want to remove this range?",
    locations: "Locations",
    newLocation: "New Location",
    failedToCreateLocation: "Failed to create location",
    editLocation: "Edit Location",
    failedToEditLocation: "Failed to edit location",
    deleteLocationTitle: "Delete location?",
    deleteLocationConfirmation: "Are you sure you want to delete this location",
    deleteLocationFailedTitle: "Deletion failed",
    deleteLocationFailedMsg: "Failed to delete location",
    status: "Status",
    allocated: "Allocated",
    pending: "Pending",
    allocatedPersonnel: "Allocated personnel",
    selectPersonnel: "Select personnel",
    deleteBandobastTitle: "Delete Bandobast",
    deleteBandobastConfirmation:
      "Are you sure you want to delete this bandobast?",
    deleteBandobastFailedTitle: "Failbandobast",
    deleteBandobastFailedMsg: "Failed to delete bandobast",
    deleteTemplateTitle: "Delete Template",
    deleteTemplateConfirmation:
      "Are you sure you want to delete this template?",
    deleteTemplateFailedTitle: "Failtemplate",
    deleteTemplateFailedMsg: "Failed to delete template",
    dateMandatory: "Date is mandatory",
    date: "Date",
    description: "Description",
    allocations: "Allocations",
    bandobastName: "Bandobast name",
    locationName: "Location name",
    timeslots: "Time slots",
    startTime: "Start time",
    endTime: "End time",
    newTimeslot: "New Timeslot",
    failedToCreateTimeslot: "Failed to create timeslot",
    startTimeMandatory: "Start time is required",
    endTimeMandatory: "End time is required",
    startDateMandatory: "Start date is required",
    endDateMandatory: "End date is required",
    endDate: "End date",
    timeslotName: "Timeslot name",
    allocationSummary: "Allocation Summary",
    timeslot: "Timeslot",
    viewLocations: "View Locations",
    selectLocation: "Select location",
    selectedLocationSet: "Select location (set)",
    schedules: "Schedules",
    table: "Table",
    map: "Map",
    hierarchial: "Hierarchial",
    resourceTemplates: "Device assessment templates",
    desc: "Description",
    resources: "Devices",
    newResource: "New Device",
    failedToCreateResource: "Failed to create device",
    deleteResourceTitle: "Delete Device?",
    deleteResourceConfirmation: "Are you sure you want to delete this device?",
    deleteResourceFailedTitle: "Failed to delete device",
    deleteResourceFailedMsg:
      "Failed to delete device. Make sure this is not used elsewhere",
    editResource: "Edit Device",
    failedToEditResource: "Failed to edit device",
    uploadResource: "Upload Device",
    failedToUploadResource: "Failed to upload devices",
    deleteResourceTemplateTitle: "Delete device template?",
    deleteResourceTemplateConfirmation:
      "Are you sure you want to delete this template?",
    deleteResourceTemplateFailedTitle: "Failed to delete template",
    deleteResourceTemplateFailedMsg: "Failed to delete template.",
    newResourceTemplate: "New Device Template",
    failedToCreateResourceTemplate: "Failed to create a new device template",
    deleteResourceAssessmentTitle: "Delete Device Assessment?",
    deleteResourceAssessmentConfirmation:
      "Are you sure you want to delete this device assessment?",
    deleteResourceAssessmentFailedTitle: "Failed to delete device assessment",
    deleteResourceAssessmentFailedMsg: "Failed to delete device assessment",
    resourceAssessments: "Device Assessments",
    personnelAssessmentCount: "Personnel Assessment Count",
    resourceAssessmentCount: "Device Assessment Count",
    resource: "Device",
    newResourceAssessment: "New Device Assessment",
    failedToCreateResourceAssessment: "Failed to create a device assessment",
    resourceTypes: "Device Types",
    newResourceType: "New Device Type",
    failedToCreateResourceType: "Failed to create device type",
    extSerialNo: "Serial No.",
    resourceType: "Device type",
    personnelAllocationCount: "Personnel allocation count",
    resourceAllocationCount: "Device allocation count",
    personnelAllocationSummary: "Personnel allocation summary",
    resourceAllocationSummary: "Device allocation summary",
    resourceAllocation: "Device allocation",
    allocatedResources: "Allocated devices",
    selectResource: "Select device",
    photo: "Photo",
    resourceTypeEmpty: "Device type is empty",
    personnelTemplate: "Personnel template",
    resourceTemplate: "Device template",
    uploadResourceTypes: "Upload device types",
    uploadResources: "Upload devices",
    checkinStatus: "Checkin Status",
    yes: "Yes",
    no: "No",
    checkinTime: "Checkin time",
    none: "None",
    liveLocationTime: "Live location time",
    liveStatus: "Live Status",
    uploadLocations: "Upload locations",
    failedToUploadLocations: "Failed to upload locations",
    deleteOrganizationTitle: "Delete Organization?",
    deleteOrganizationConfirmation:
      "Are you sure you want to delete this organization?",
    deleteOrganizationFailedTitle: "Failed to delete",
    deleteOrganizationFailedMsg:
      "Failed to delete organization. Make sure no entities are associated with it",
    organizations: "Organizations",
    newOrganization: "New organization",
    failedToCreateOrganization: "Failed to create organization",
    editOrganization: "Edit organization",
    failedToEditOrganization: "Failed to edit organization",
    parentOrg: "Parent organization",
    supervisorNameMandatory: "Supervisor name is required",
    supervisorMobileMandatory: "Supervisor mobile is required",
    supervisorName: "Name of the supervisor",
    supervisorMobile: "Mobile of the supervisor",
    leftLogo: "Left logo",
    rightLogo: "Right logo",
    signature: "Signature",
    deleteResourceTypeTitle: "Delete Device Type?",
    deleteResourceTypeConfirmation:
      "Are you sure you want to delete this Device type?",
    deleteResourceTypeFailedTitle: "Failed to delete device type",
    deleteResourceTypeFailedMsg:
      "Failed to delete device type. Try again later.",
    editResourceAssessment: "Edit Device assessment",
    failedToEditResourceAssessment: "Failed to update this device assessment.",
    editPersonnelAssessmentTemplate: "Edit Personnel Assessment Template",
    editResourceAssessmentTemplate: "Edit Device Assessment Template",
    failedToEditResourceAssessmentTemplate:
      "Failed to edit device assessment template",
    deleteTimeslotTitle: "Delete Timeslot?",
    deleteTimeslotConfirmation:
      "Are you sure you want to delete this timeslot?",
    deleteTimeslotFailedTitle: "Failed to delete",
    deleteTimeslotFailedMsg: "Failed to delete timeslot",
    editTimeslot: "Edit Timeslot",
    failedToEditTimeslot: "Failed to edit timeslot",
    startDateLaterThanEndDate: "Start date cannot be later than end date",
    invalidTimeFormat: "Invalid time format. Should be in HH:MM format",
    designationMandatory: "Designation is required",
    countMandatory: "Count is required",
    countShouldBeNumber: "Count should be a positive number",
    resourceTypeMandatory: "Device type is required",
    moveUp: "Move Up",
    moveDown: "Move Down",
    reports: "Reports",
    assessmentReport: "Assessment",
    allocationReport: "Allocations",
    assessmentAllocationSummary: "Assessment & Allocation Summary",
    externalForces: "External forces",
    newExternalForce: "New External force",
    failedToCreateExternalForce: "Failed to add external force.",
    uploadExternalForces: "Upload external forces",
    failedToImportExternalForces: "Failed to import external forces",
    deleteExternalForceTitle: "Delete External force?",
    deleteExternalForceConfirmation:
      "Are you sure you want to delete this external force?",
    deleteExternalForceFailedTitle: "Failed to delete external force!",
    deleteExternalForceFailedMsg:
      "Failed to delete external force. Make sure he is not allocated to any bandobast",
    total: "Total",
    showAssessmentCount: "Show assessment count",
    showAllocationCount: "Show allocation count",
    showAllocationPending: "Show allocation pending count",
    abbreviation: "Abbreviation",
    createDefaultTimeslot: "Create a default timeslot?",
    overview: "Overview",
    rangeCount: "No. of ranges",
    areaCount: "No. of areas",
    subareaCount: "No. of subareas",
    pointCount: "No. of points",
    editResourceType: "Edit Device Type",
    personnelAssessmentAllocationSummary: "Personnel Assessment & Allocation",
    resourceAssessmentAllocationSummary: "Device Assessment & Allocation",
  },

  gu: {
    users: "વપરાશકર્તાઓ",
    actions: "ક્રિયાઓ",
    roles: "ભૂમિકાઓ",
    add: "ઉમેરો",
    delete: "કાઢી નાખો",
    edit: "સંપાદિત કરો",
    new: "નવી",
    defaultDeleteTitle: "કાઢી નાખીએ?",
    defaultDeleteMsg: "શું તમે ખરેખર આને કાઢી નાખવા માંગો છો?",
    disagree: "અસંમત",
    agree: "સંમત",
    defaultDeleteFailedTitle: "કાઢી નાખવામાં નિષ્ફળ",
    defaultDeleteFailedMsg:
      "આઇટમ કાઢી નાખવામાં નિષ્ફળ. ખાતરી કરો કે તે અન્ય કંઈપણ સાથે સંકળાયેલ નથી.",
    close: "બંધ",
    error: "ભૂલ",
    audit: "ઓડિટ લોગ્સ",
    changePwd: "પાસવર્ડ બદલો",
    details: "વિગતો",
    userId: "વપરાશકર્તા ID",
    parameters: "પરિમાણો",
    timestamp: "ટાઈમસ્ટેમ્પ",
    failedToLoadAuditLogs: "ઓડિટ લોગ લોડ કરવામાં નિષ્ફળ",
    userName: "User name (GU)",
    auditLogs: "ઓડિટ લોગ્સ",
    failedToCreateRole: "ભૂમિકા બનાવવામાં નિષ્ફળ",
    failedToLoadRoles: "Failed to load roles (GU)",
    nameMandatory: "નામ જરૂરી છે",
    name: "નામ",
    cancel: "રદ કરો",
    create: "બનાવો",
    failedToLoadPermissions: "પરવાનગીઓ લોડ કરવામાં નિષ્ફળ",
    export: "નિકાસ",
    action: "ક્રિયા",
    remove: "દૂર કરો",
    select: "પસંદ કરો",
    removePermissionTitle: "પરવાનગી કાઢી નાખીએ?",
    removePermissionConfirmation: "શું તમે ખરેખર આ પરવાનગી દૂર કરવા માંગો છો?",
    selectPermissions: "પરવાનગીઓ પસંદ કરો",
    deleteRoleTitle: "ભૂમિકા કાઢી નાખીએ?",
    deleteRoleConfirmation: "શું તમે ખરેખર આ ભૂમિકા કાઢી નાખવા માંગો છો?",
    roleDeleteFailedTitle: "ભૂમિકા કાઢી નાખવાનું નિષ્ફળ થયું",
    roleDeleteFailedMsg:
      "ભૂમિકા કાઢી નાખવાનું નિષ્ફળ થયું. ફરી પ્રયાસ કરતા પહેલા ખાતરી કરો કે કોઈ વપરાશકર્તાને આ ભૂમિકા સોંપવામાં આવી નથી.",
    permissions: "પરવાનગીઓ",
    oldPasswordMandatory: "જૂનો પાસવર્ડ જરૂરી છે",
    newPasswordMandatory: "નવો પાસવર્ડ જરૂરી છે",
    shortPassword: "પાસવર્ડ ઘણો નાનો છે (ઓછામાં ઓછા {0} અક્ષરો)",
    samePasswords: "જૂના અને નવા પાસવર્ડ સરખા ન હોઈ શકે.",
    changePwdFailedTitle: "ભૂલ",
    oldPassword: "જુનો પાસવર્ડ",
    newPassword: "નવો પાસવર્ડ",
    change: "બદલો",
    save: "સાચવો",
    usernameMandatory: "વપરાશકર્તા નામ જરૂરી છે",
    passwordMandatory: "પાસવર્ડ અનિવાર્ય છે",
    login: "પ્રવેશ કરો",
    password: "પાસવર્ડ",
    loginFailedTitle: "Login failed",
    loginFailedMsg: "Make sure username/password is correct.",
    createUser: "વપરાશકર્તા બનાવો",
    registrationFailedTitle: "નોંધણી નિષ્ફળ",
    registrationFailedMsg: "સંભવતઃ વપરાશકર્તા નામ અનન્ય નથી. એક અલગ પ્રયાસ કરો",
    username: "વપરાશકર્તા નામ",
    next: "આગળ",
    finish: "સમાપ્ત કરો",
    resetPwd: "પાસવર્ડ રીસેટ કરો",
    newPasswd: "નવો પાસવર્ડ",
    update: "ટિપ્પણી",
    back: "પાછળ",
    removeRoleTitle: "ભૂમિકા કાઢી નાખીએ?",
    removeRoleConfirmation: "શું તમે ખરેખર આ ભૂમિકા દૂર કરવા માંગો છો?",
    selectRoles: "ભૂમિકાઓ પસંદ કરો",
    deleteUserTitle: "Delete User (GU)",
    deleteUserConfirmation: "Are you sure you want to delete this user? (GU)",
    deleteUserFailedTitle: "Failure (GU)",
    deleteUserFailedMsg: "Failed to delete user (GU)",
    failedToLoadUsers: "વપરાશકર્તાઓને લોડ કરવામાં નિષ્ફળ",
    editUser: "વપરાશકર્તા સંપાદિત કરો",
    resetPasswd: "પાસવર્ડ રીસેટ કરો",
    changePwdFailedMsg: "Unable to change password (GU)",
    bandobast: "Bandobast (GU)",
    serialNo: "Serial No. (GU)",
    newBandobast: "New Bandobast (GU)",
    failedToCreateBandobast:
      "Failed to create a new bandobast. Is the name unique? (GU)",
    points: "Points (GU)",
    failedToCreatePoint: "Failed to create Points. Is the name unique? (GU)",
    newPoint: "New Point (GU)",
    personnelAssessment: "Personnel Assessment (GU)",
    newPersonnelAssessment: "New Personnel Assessment (GU)",
    failedToCreatePersonnelAssessment:
      "Failed to create personnel assessment. Is the designation already used? (GU)",
    count: "Count (GU)",
    designations: "Designations (GU)",
    newDesignation: "New Designation (GU)",
    failedToCreateDesignation:
      "Failed to create designation. Is the designation already used? (GU)",
    designation: "Designation (GU)",
    deletePersonnelAssessmentTitle: "Delete Personnel Assessment? (GU)",
    deletePersonnelAssessmentConfirmation:
      "Are you sure you want to delete this assessment? (GU)",
    deletePersonnelAssessmentFailedTitle: "Failed to delete assessment (GU)",
    deletePersonnelAssessmentFailedMsg:
      "Failed to delete this personnel assessment. Try again later. (GU)",
    editPersonnelAssessment: "Edit Personnel assessment (GU)",
    failedToEditPersonnelAssessment:
      "Failed to update this personnel assessment. Try again later. (GU)",
    ranges: "Ranges (GU)",
    failedToCreateRange: "Failed to create range. Is the name unique? (GU)",
    areas: "Areas (GU)",
    subareas: "Sub areas (GU)",
    newArea: "New Area (GU)",
    failedToCreateArea: "Failed to create area. Is the name unique? (GU)",
    range: "Range (GU)",
    area: "Area (GU)",
    newSubarea: "New Subarea (GU)",
    failedToCreateSubarea:
      "Failed to create sub area. Is the name unique? (GU)",
    subarea: "Sub area (GU)",
    personnelAssessments: "Personnel Assessments (GU)",
    personnel: "Personnel (GU)",
    newPersonnel: "New Personnel (GU)",
    failedToCreatePersonnel: "Failed to add personnel (GU)",
    personnelAllocation: "Personnel Allocation (GU)",
    location: "Location (GU)",
    submit: "Submit (GU)",
    assessmentCount: "Assessment count (GU)",
    allocatedCount: "Allocated count (GU)",
    allocationLink: "Edit allocation (GU)",
    parent: "Parent (GU)",
    link: "Link (GU)",
    designationEmpty: "Designation is empty in row {0} (GU)",
    valuesEmpty: "Value is empty in row {0} (GU)",
    point: "Point (GU)",
    kind: "Kind (GU)",
    summary: "Summary (GU)",
    allocate: "Allocate (GU)",
    deletePersonnelTitle: "કર્મચારીઓને કાઢી નાખો",
    deletePersonnelConfirmation:
      "શું તમે ખરેખર આ કર્મચારીને કાઢી નાખવા માંગો છો?",
    deletePersonnelFailedTitle: "નિષ્ફળ જવાનો",
    deletePersonnelFailedMsg: "કર્મચારીઓને કાઢી નાખવામાં નિષ્ફળ",
    templates: "Personnel assessment templates (GU)",
    template: "Template (GU)",
    address: "Address (GU)",
    nameEmpty: "Name is empty in row {0} (GU)",
    kindEmpty: "Kind is empty in row {0} (GU)",
    parentEmpty: "Parent is empty in row {0} (GU)",
    templateEmpty: "Template is empty in row {0} (GU)",
    validationErrors: "Validation errors (GU)",
    newBandobastPage1: "New Bandobast (Step 1 of 2: Details) (GU)",
    newBandobastPage2: "New Bandobast (Step 2 of 2: Locations) (GU)",
    startDate: "Start Date (GU)",
    heading: "Heading (GU)",
    subHeading: "Sub heading (GU)",
    place: "Place (GU)",
    city: "City (GU)",
    unit: "Unit (GU)",
    district: "District (GU)",
    bandobastCreationFailed:
      "Bandobast creation failed. Is the name alreay used? (GU)",
    newTemplate: "New Template (GU)",
    countEmpty: "Count is empty in row {0} (GU)",
    assessmentsEmpty: "There should be atleast one assessment (GU)",
    invalidCount: "Invalid count value (GU)",
    assessments: "Assessments (GU)",
    failedToCreateTemplate: "Failed to create template (GU)",
    failedToEditTemplate: "Failed to edit template (GU)",
    editBandobast: "Edit Bandobast (GU)",
    bandobastEditFailed: "Edit bandobast failed (GU)",
    failedToEditBandobast: "Failed to edit bandobast (GU)",
    import: "Import (GU)",
    uploadPersonnel: "Upload personnel (GU)",
    upload: "Upload (GU)",
    failedToImportPersonnel: "Failed to added personnel (GU)",
    editPersonnel: "Edit Personnel (GU)",
    failedToEditPersonnel: "Failed to edit personnel (GU)",
    editRange: "Edit Range (GU)",
    failedToEditRange: "Failed to edit range (GU)",
    editArea: "Edit Area (GU)",
    failedToEditArea: "Failed to edit area (GU)",
    editSubarea: "Edit Subarea (GU)",
    failedToEditSubarea: "Failed to edit subarea (GU)",
    editPoint: "Edit Point (GU)",
    failedToEditPoint: "Failed to edit point (GU)",
    editDesignation: "Edit Designation (GU)",
    failedToEditDesignation: "Failed to edit designation (GU)",
    deleteDesignationTitle: "Delete designation? (GU)",
    deleteDesignationConfirmation:
      "Are you sure you want to delete this designation? (GU)",
    deleteDesignationFailedTitle: "Designation delete failed (GU)",
    deleteDesignationFailedMsg: "Failed to delete designation (GU)",
    uploadDesignation: "Upload designations (GU)",
    failedToUploadDesignation: "Failed to upload designations (GU)",
    deleteRangeFailedTitle: "Range removal failed (GU)",
    deleteRangeFailedMsg: "Failed to remove range (GU)",
    deleteRangeTitle: "Remove range (GU)",
    deleteRangeConfirmation: "Are you sure you want to remove this range? (GU)",
    locations: "Locations (GU)",
    newLocation: "New Location (GU)",
    failedToCreateLocation: "Failed to create location (GU)",
    editLocation: "Edit Location (GU)",
    failedToEditLocation: "Failed to edit location (GU)",
    deleteLocationTitle: "Delete location? (GU)",
    deleteLocationConfirmation:
      "Are you sure you want to delete this location (GU)",
    deleteLocationFailedTitle: "Deletion failed (GU)",
    deleteLocationFailedMsg: "Failed to delete location (GU)",
    status: "Status (GU)",
    allocated: "Allocated (GU)",
    pending: "Pending (GU)",
    allocatedPersonnel: "Allocated personnel (GU)",
    selectPersonnel: "Select personnel (GU)",
    deleteBandobastTitle: "Delete Bandobast (GU)",
    deleteBandobastConfirmation:
      "Are you sure you want to delete this bandobast? (GU)",
    deleteBandobastFailedTitle: "Failbandobast (GU)",
    deleteBandobastFailedMsg: "Failed to delete bandobast (GU)",
    deleteTemplateTitle: "Delete Template (GU)",
    deleteTemplateConfirmation:
      "Are you sure you want to delete this template? (GU)",
    deleteTemplateFailedTitle: "Failtemplate (GU)",
    deleteTemplateFailedMsg: "Failed to delete template (GU)",
    dateMandatory: "Date is mandatory (GU)",
    date: "Date (GU)",
    description: "Description (GU)",
    allocations: "Allocations (GU)",
    bandobastName: "Bandobast name (GU)",
    locationName: "Location name (GU)",
    timeslots: "Time slots (GU)",
    startTime: "Start time (GU)",
    endTime: "End time (GU)",
    newTimeslot: "New Timeslot (GU)",
    failedToCreateTimeslot: "Failed to create timeslot (GU)",
    startTimeMandatory: "Start time is required (GU)",
    endTimeMandatory: "End time is required (GU)",
    startDateMandatory: "Start date is required (GU)",
    endDateMandatory: "End date is required (GU)",
    endDate: "End date (GU)",
    timeslotName: "Timeslot name (GU)",
    allocationSummary: "Allocation Summary (GU)",
    timeslot: "Timeslot (GU)",
    viewLocations: "View locations (GU)",
    selectLocation: "Select location (GU)",
    selectedLocationSet: "Select location (set) (GU)",
    schedules: "Schedules (GU)",
    mobileNumber: "Mobile No. (GU)",
    idNumber: "Id No. (GU)",
    table: "Table (GU)",
    map: "Map (GU)",
    hierarchial: "Hierarchial (GU)",
    resourceTemplates: "Device assessment templates (GU)",
    desc: "Description (GU)",
    resources: "Devices (GU)",
    newResource: "New Device (GU)",
    failedToCreateResource: "Failed to create device (GU)",
    deleteResourceTitle: "Delete Device? (GU)",
    deleteResourceConfirmation:
      "Are you sure you want to delete this device? (GU)",
    deleteResourceFailedTitle: "Failed to delete device (GU)",
    deleteResourceFailedMsg:
      "Failed to delete device. Make sure this is not used elsewhere (GU)",
    editResource: "Edit Device (GU)",
    failedToEditResource: "Failed to edit device (GU)",
    uploadResource: "Upload Device (GU)",
    failedToUploadResource: "Failed to upload devices (GU)",
    deleteResourceTemplateTitle: "Delete device template? (GU)",
    deleteResourceTemplateConfirmation:
      "Are you sure you want to delete this template? (GU)",
    deleteResourceTemplateFailedTitle: "Failed to delete template (GU)",
    deleteResourceTemplateFailedMsg: "Failed to delete template.(GU)",
    newResourceTemplate: "New Device Template (GU)",
    failedToCreateResourceTemplate:
      "Failed to create a new device template (GU)",
    deleteResourceAssessmentTitle: "Delete Device Assessment? (GU)",
    deleteResourceAssessmentConfirmation:
      "Are you sure you want to delete this device assessment? (GU)",
    deleteResourceAssessmentFailedTitle:
      "Failed to delete device assessment (GU)",
    deleteResourceAssessmentFailedMsg:
      "Failed to delete device assessment (GU)",
    resourceAssessments: "Device Assessments (GU)",
    personnelAssessmentCount: "Personnel Assessment Count (GU)",
    resourceAssessmentCount: "Device Assessment Count (GU)",
    resource: "Device (GU)",
    newResourceAssessment: "New Device Assessment (GU)",
    failedToCreateResourceAssessment:
      "Failed to create a device assessment (GU)",
    resourceTypes: "Device Types (GU)",
    newResourceType: "New Device Type (GU)",
    failedToCreateResourceType: "Failed to create device type (GU)",
    extSerialNo: "Serial No. (GU)",
    resourceType: "Device type (GU)",
    personnelAllocationCount: "Personnel allocation count (GU)",
    resourceAllocationCount: "Device allocation count (GU)",
    personnelAllocationSummary: "Personnel allocation summary (GU)",
    resourceAllocationSummary: "Device allocation summary (GU)",
    resourceAllocation: "Device allocation (GU)",
    allocatedResources: "Allocated devices (GU)",
    selectResource: "Select device (GU)",
    photo: "Photo (GU)",
    resourceTypeEmpty: "Device type is empty (GU)",
    personnelTemplate: "Personnel template (GU)",
    resourceTemplate: "Device template (GU)",
    uploadResourceTypes: "Upload device types (GU)",
    uploadResources: "Upload devices (GU)",
    checkinStatus: "Checkin Status (GU)",
    yes: "Yes (GU)",
    no: "No (GU)",
    checkinTime: "Checkin time (GU)",
    none: "None (GU)",
    liveLocationTime: "Live location time (GU)",
    liveStatus: "Live Status (GU)",
    uploadLocations: "Upload locations (GU)",
    failedToUploadLocations: "Failed to upload locations (GU)",
    deleteOrganizationTitle: "Delete Organization? (GU)",
    deleteOrganizationConfirmation:
      "Are you sure you want to delete this organization? (GU)",
    deleteOrganizationFailedTitle: "Failed to delete (GU)",
    deleteOrganizationFailedMsg:
      "Failed to delete organization. Make sure no entities are associated with it (GU)",
    organizations: "Organizations (GU)",
    newOrganization: "New organization (GU)",
    failedToCreateOrganization: "Failed to create organization (GU)",
    editOrganization: "Edit organization (GU)",
    failedToEditOrganization: "Failed to edit organization (GU)",
    parentOrg: "Parent organization (GU)",
    organization: "Organization (GU)",
    supervisorNameMandatory: "Supervisor name is required (GU)",
    supervisorMobileMandatory: "Supervisor mobile is required (GU)",
    supervisorName: "Name of the supervisor (GU)",
    supervisorMobile: "Mobile of the supervisor (GU)",
    leftLogo: "Left logo (GU)",
    rightLogo: "Right logo (GU)",
    signature: "Signature (GU)",
    deleteResourceTypeTitle: "Delete Device Type? (GU)",
    deleteResourceTypeConfirmation:
      "Are you sure you want to delete this Device type? (GU)",
    deleteResourceTypeFailedTitle: "Failed to delete device type (GU)",
    deleteResourceTypeFailedMsg:
      "Failed to delete device type. Try again later. (GU)",
    editResourceAssessment: "Edit Device assessment (GU)",
    failedToEditResourceAssessment:
      "Failed to update this device assessment. (GU)",
    editPersonnelAssessmentTemplate: "Edit Personnel Assessment Template (GU)",
    editResourceAssessmentTemplate: "Edit Device Assessment Template (GU)",
    failedToEditResourceAssessmentTemplate:
      "Failed to edit device assessment template (GU)",
    deleteTimeslotTitle: "Delete Timeslot? (GU)",
    deleteTimeslotConfirmation:
      "Are you sure you want to delete this timeslot? (GU)",
    deleteTimeslotFailedTitle: "Failed to delete (GU)",
    deleteTimeslotFailedMsg: "Failed to delete timeslot (GU)",
    editTimeslot: "Edit Timeslot (GU)",
    failedToEditTimeslot: "Failed to edit timeslot (GU)",
    startDateLaterThanEndDate: "Start date cannot be later than end date (GU)",
    invalidTimeFormat: "Invalid time format. Should be in HH:MM format (GU)",
    designationMandatory: "Designation is required (GU)",
    countMandatory: "Count is required (GU)",
    countShouldBeNumber: "Count should be a positive number (GU)",
    resourceTypeMandatory: "Device type is required (GU)",
    moveUp: "Move Up (GU)",
    moveDown: "Move Down (GU)",
    reports: "Reports (GU)",
    assessmentReport: "Assessment (GU)",
    allocationReport: "Allocations (GU)",
    assessmentAllocationSummary: "Assessment & Allocation Summary (GU)",
    externalForces: "External forces (GU)",
    newExternalForce: "New External force (GU)",
    failedToCreateExternalForce: "Failed to add external force. (GU)",
    uploadExternalForces: "Upload external forces (GU)",
    failedToImportExternalForces: "Failed to import external forces (GU)",
    deleteExternalForceTitle: "Delete External force? (GU)",
    deleteExternalForceConfirmation:
      "Are you sure you want to delete this external force? (GU)",
    deleteExternalForceFailedTitle: "Failed to delete external force (GU)",
    deleteExternalForceFailedMsg:
      "Failed to delete external force. Make sure he is not allocated to any bandobast (GU)",
    total: "Total (GU)",
    showAssessmentCount: "Show assessment count (GU)",
    showAllocationCount: "Show allocation count (GU)",
    showAllocationPending: "Show allocation pending count (GU)",
    abbreviation: "Abbreviation (GU)",
    createDefaultTimeslot: "Create a default timeslot? (GU)",
    overview: "Overview (GU)",
    rangeCount: "No. of ranges (GU)",
    areaCount: "No. of areas (GU)",
    subareaCount: "No. of subareas (GU)",
    pointCount: "No. of points (GU)",
    editResourceType: "Edit Device Type (GU)",
    personnelAssessmentAllocationSummary:
      "Personnel Assessment & Allocation (GU)",
    resourceAssessmentAllocationSummary: "Device Assessment & Allocation (GU)",
  },
});

export default strings;
